<template>
  <div class="guard">
    <div class="main-bg">
      <!-- <img src="./pc.jpg" alt=""> -->
    </div>
    <div class="main-txt">
      <!-- <div class="main-txt-bg"></div> -->
      <div class="p-txt" style="margin-top:0">
        各位猎上网的猎头伙伴们：
      </div>
      <div class="p-txt">
        大家好！2020年，一场疫情来的猝不及防，不少企业在春天即将到来之际，感受到了寒冬的萧瑟。新冠肺炎疫情蔓延，在做好自我隔离保护措施的前提下，“云办公”成了复工的临时措施。即使很多企业在努力复工，但是面对的困难依然巨大。疫情尚未解除，为了控制蔓延，隔离还在继续。猎上网深知有着成千上万的猎头伙伴正与我们一道并肩作战！
      </div>
      <div class="p-txt">
        自2020年2月开工以来，各个猎企及猎头顾问们在如今的办公场景下，遇到了困难，遇到了瓶颈，尤其是依托线下场景生存的猎企业务受到了不小的制约。我们接到了很多猎企老板打来的电话，讲述了他们目前遇到的困难：客户无法拜访，职位量不足，职位信息获取不完整，顾问开工率不足，顾问远程办公受限制，无法组织高效的培训等等。
      </div>
      <div class="p-txt">
        作为「社会化猎头招聘服务平台」，猎上网一直致力于为猎头伙伴们提供可靠的服务。我们这两周以来一直保持着和平台大多数客户的沟通，提前预定客户招聘需求，为平台的猎企伙伴开发出来了数以万计的职位供平台猎企伙伴们推荐；自2月3日开工至今，各项数据（在线雇主数、新增雇主数、平台在线职位数、新发职位数、新增猎企数、新增猎头数、活跃HR数、活跃猎头数等）已经达到了去年同期水平，新增HC数开工当天破千，日均推荐量已恢复且略超过去年同期水平，且每天有着1W余次AI人岗匹配数据，大大超过年前。
      </div>
      <div class="p-txt">
        为了帮助更多猎企和猎头伙伴度过难关，猎上网决定推出全平台95%分佣、义务开通马老师咨询专线、开通猎头合作绿色通道、猎上大学推出百门免费课程等五大方面的扶持措施！
      </div>
      <div class="p-txt">
        猎上网疫情期间扶持猎头政策包括：
      </div>
      <div class="p-txt">
        一、平台猎头佣金减免：<br />
        3月1日 - 疫情结束，期间平台产生的所有推荐，猎企享95%分佣。<br />
        为猎上网平台合作的猎企伙伴们创造更宽松的条件，支持大家更好的度过经济难关！
      </div>
      <div class="p-txt">
        二、开通猎头与猎企「疫情扶持专区」<br />
        1、扶持落单猎头及有需求猎企渡疫情<br />
        为受疫情影响的落单猎头提供工作机会（有需求的猎头个人通过猎上网「疫情帮扶专区」自主选择求职与合作机会，按提示操作后上传简历，猎上网会经猎头同意后将猎头个人所提供的信息分享给合作猎企，增加猎头工作机会）。<br />
        同时，有招聘猎头顾问需求的猎企也可直接与猎上网联系，猎上网将经猎头同意后把有需求的个人猎头的求职信息分享给猎企。<br />
        2、提供猎企合作绿色通道<br />
        猎上网通过绿色通道，每周一、三、五为猎头用户提供「最新职位+雇主需求+职位供需」List。<br />
        针对猎头用户擅长领域，猎上网会将职位分类，以匹配给对应方向的猎头。针对不同职位、不同公司，组建猎企联合运营群，对应职位PA（运营小二）将实时回复反馈，辅助猎企进行数据管理，做到职位精准对接。<br />
        为猎头用户在疫情期间能迅速找到更多合适的职位与雇主，猎上网会在助力大家盘活自身已有资源的同时，再为各位猎头用户伙伴补充更多缺失的资源，为其提供职位或者Offer画像，提高猎头用户做单效率。
      </div>
      <div class="p-btn">
        <van-button plain type="primary" @click="goSelect">猎头寻求工作</van-button>
        <van-button plain type="primary" @click="goBus">猎企寻求合作</van-button>
      </div>
      <div class="p-txt">
        三、义务开通马老师咨询业务小分队服务：<br />
      在当下受疫情影响期间，猎头小伙伴们遇见多种困境，比如——顾问工作积极性不高怎么办？受疫情影响猎头职场遇见了瓶颈，如何在危机中更上一层楼？疫情阶段猎企如何扩张业绩如何提升？猎头公司如何开设？<br />
      诸如此类的问题，马老师团队都会为猎头伙伴提供业务咨询，帮助大家解决一系列与自身生存休戚相关的问题。并且将共性的、大家都非常关心的问题，做成免费课程分享给各位猎头伙伴！<br />
      无论您是否已经在猎上网注册，只要您从事猎头行业，马老师团队都将为各位猎头伙伴提供最专业的问题解答以及帮助，只要与猎头伙伴们有关的问题，在这里都会找到答案。<br />
      </div>
      <div class="p-btn">
        <a class="van-button van-button--primary van-button--normal van-button--plain" href="https://appxztcudrm9590.h5.xiaoeknow.com/content_page/eyJ0eXBlIjo1LCJyZXNvdXJjZV90eXBlIjoiIiwicmVzb3VyY2VfaWQiOiIiLCJwcm9kdWN0X2lkIjoicV81ZTQ2MTVkMzA1Nzg2X3BIWW1WUDg4IiwiYXBwX2lkIjoiYXBwWHp0Q3Vkcm05NTkwIn0">马老师在线解答</a>
        
      </div>
      <div class="p-txt">
        四、职位反馈绿色通道：<br />
        沟通工具IM升级，猎企顾问通过IM提出的问题猎上网PA将在1小时内处理完毕并作出有效回复，全力确保职位反馈沟通流畅。
      </div>
      <div class="p-txt">
        五、猎上大学推出百门免费课程：<br />
        猎上大学推出近百门在线课程，全部免费开放。猎头可通过课程，学习各类必备的知识和技能，助力提升高端与人选沟通技能、更好掌握猎头工作窍门、更快完成年度业绩目标。
      </div>
      <div class="p-txt">
        无论何时何地，猎上网将与各位猎头伙伴一起上下同心、网罗天下！<br />
        共克时艰，共创未来！<br />
        相信寒冬时节的努力，会带来充满生机的春天！<br />
        武汉加油！中国必胜！
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "guard",
  props: {
    
  },
  data(){
    return {
     
    }
  },
  watch: {
   
  },
  created() {
	  this.$store.commit('comp/WX_SHARE',{
      title:'守卫猎头计划开启',
      desc:'猎上网推出五大扶持猎头政策',
      link:window.location.origin + '/hh-wx/activity/guardhunter'
    });
  },
  methods: {
    goSelect(){
      this.$router.push('/activity/guard/select')
    },
    goBus(){
      this.$router.push('/activity/guard/business')
    }
  }
};

</script>


<style scoped lang="scss">
  .guard {
    width:100%;
    color:#fff;
    background:#25c1e3;
    font-size:16px;
    
    
    
    .main-bg {
      max-width:1440px;
      height:606px;
      background: url('./1.jpg') no-repeat center top;
      background-size: 1440px 100%;
      margin:0 auto;
      img {
        width:100%;
      }
      // background: url('./bg.jpg') no-repeat left top;
      // background-size:100%;
    }
    .main-txt {
      padding-bottom:50px;
      width:800px;
      margin:0 auto;
      
      padding: 20px;
      margin-top:-240px;
      // background-color:rgba(0,0,0,0.2);
      background: url('./p.png') repeat;
      
      .p-txt {
        margin-top:20px;
      }
      .p-btn {
        margin-top:10px;
        margin-bottom:20px;
        
        .van-button {
          margin-right: 20px;
          background: #fff;
          color:#333;
          border:1px solid #333;
          cursor: pointer;
        }
      }
    }
  }
</style>
